import { connect } from "react-redux";
import PremierDeliveryFAQs from "../../components/PremierDeliveryFAQs/index.jsx";

const mapStateToProps = (state) => ({
  premierDeliveryFAQs: state.PremierPageFrame.content.premierDeliveryFAQs,
});

export default connect(mapStateToProps)(PremierDeliveryFAQs);
